import React from 'react';
import TabPanel from "../../TabPanel";
import { SettingsModalTabProps } from '../../types';
import UserList from '../UserList';
import AccessContainer from '../AccessContainer';
import { Grid } from '@mui/material';
import PermissionMatrixProvider from '@/Contexts/PermissionMatrix/Provider';

const PermissionsTab: React.FC<SettingsModalTabProps> = ({ parentTab, index }) => {
  return (
    <TabPanel value={parentTab} index={index} fillHeight>
      <PermissionMatrixProvider>
        <Grid container height="100%" alignContent="flex-start" flex={1} sx={{ minHeight: 0 }} data-testid="permissions-grid-container">
          <UserList />
          <AccessContainer />
        </Grid>
      </PermissionMatrixProvider>
    </TabPanel>
  );
};

export default PermissionsTab;
